/**
 * Tough Mother Custom Flavor Mega Menu & Mobile Drawer Interactions
 */
(() => {
  function initFlavorMegaMenus() {
    /* ==========================================================================
       1. Desktop Mega Menu Interactivity (Centralized Hover Manager)
       ========================================================================== */
    const megaMenuPanels = document.querySelectorAll('.custom-flavor-mega-menu-panel');
    const megaMenuOverlays = document.querySelectorAll('.custom-mega-menu-overlay');

    let activePanel = null;
    let closeTimer = null;
    let switchTimer = null;

    const updateMenuPosition = (panel) => {
      if (!panel) return;
      const headerEl = document.querySelector('.header-section, #header-component, header, .header, #headerBorderWrap, [data-sticky-header], .site-header, header[data-header-component]');
      if (headerEl) {
        const rect = headerEl.getBoundingClientRect();
        const bottomPos = Math.max(rect.bottom, 48);
        const topGap = 10;
        const finalTop = bottomPos + topGap;
        panel.style.top = `${finalTop}px`;
        panel.style.maxHeight = `calc(100vh - ${finalTop + 16}px)`;
        megaMenuOverlays.forEach(overlay => {
          overlay.style.top = `${bottomPos}px`;
          overlay.style.height = `calc(100vh - ${bottomPos}px)`;
        });
      }
    };

    const openPanel = (panel) => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);

      if (activePanel && activePanel !== panel) {
        activePanel.classList.remove('is-open');
      }

      activePanel = panel;
      setupTabs(panel);
      updateMenuPosition(panel);
      panel.classList.add('is-open');
      megaMenuOverlays.forEach(o => o.classList.add('is-active'));
      updateAllCarousels(panel);
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);
      closeTimer = setTimeout(() => {
        if (activePanel) {
          activePanel.classList.remove('is-open');
          activePanel = null;
        }
        megaMenuOverlays.forEach(o => o.classList.remove('is-active'));
      }, 350);
    };

    const cancelClose = () => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);
    };

    // Sub-Tabs Generator & Switcher
    const setupTabs = (panel) => {
      if (!panel) return;
      const subTabsNav = panel.querySelector('.flavor-sub-tabs');
      const tabPanels = panel.querySelectorAll('.flavor-panel-content');

      if (!subTabsNav || tabPanels.length === 0) return;

      const currentTabItems = subTabsNav.querySelectorAll('.flavor-tab-item');
      if (currentTabItems.length !== tabPanels.length) {
        subTabsNav.innerHTML = '';

        tabPanels.forEach((p, index) => {
          const title = p.getAttribute('data-tab-title') || `FLAVOR ${index + 1}`;
          const panelId = p.id || `flavor-panel-${index}`;
          p.id = panelId;

          const li = document.createElement('li');
          li.className = `flavor-tab-item ${index === 0 ? 'is-active' : ''}`;
          li.setAttribute('role', 'presentation');
          li.setAttribute('data-tab-target', panelId);

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'flavor-tab-btn';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
          btn.textContent = title;

          li.appendChild(btn);
          subTabsNav.appendChild(li);

          const activateTab = (e) => {
            if (e) e.preventDefault();
            subTabsNav.querySelectorAll('.flavor-tab-item').forEach(t => {
              t.classList.remove('is-active');
              const b = t.querySelector('.flavor-tab-btn');
              if (b) b.setAttribute('aria-selected', 'false');
            });
            tabPanels.forEach(tp => tp.classList.remove('is-active'));

            li.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
            p.classList.add('is-active');

            setTimeout(() => updateAllCarousels(panel), 50);
          };

          li.addEventListener('mouseenter', activateTab);
          li.addEventListener('click', activateTab);
        });

        const hasActive = Array.from(tabPanels).some(p => p.classList.contains('is-active'));
        if (!hasActive && tabPanels[0]) {
          tabPanels[0].classList.add('is-active');
        }
      }
    };

       // Coordinated Nav Triggers
    document.querySelectorAll('[data-mega-menu-trigger]').forEach(trigger => {
      const menuType = trigger.getAttribute('data-mega-menu-trigger');
      const targetPanel = trigger.querySelector('.custom-flavor-mega-menu-panel') ||
        document.getElementById(menuType === 'variety-pack' ? 'variety-mega-menu-panel' : 'flavor-mega-menu-panel');

      if (!targetPanel) return;

      
      const navLink = trigger.querySelector(':scope > a') || trigger.querySelector('a');

      if (navLink) {
        navLink.addEventListener('mouseenter', () => {
          cancelClose();
          if (activePanel !== targetPanel) {
            openPanel(targetPanel);
          }
        });
      }

      trigger.addEventListener('mouseleave', (e) => {
        const related = e.relatedTarget;
        if (related && (related.closest('.custom-flavor-mega-menu-panel') || related.closest('[data-mega-menu-trigger] > a'))) {
          return;
        }
        scheduleClose();
      });
    });

    megaMenuPanels.forEach(panel => {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', (e) => {
        const related = e.relatedTarget;
        if (related && related.closest('[data-mega-menu-trigger] > a')) {
          return;
        }
        scheduleClose();
      });
      setupTabs(panel);
      updateAllCarousels(panel);
    });

    megaMenuOverlays.forEach(overlay => {
     
      overlay.addEventListener('mouseenter', scheduleClose);
      overlay.addEventListener('click', () => {
        clearTimeout(closeTimer);
        if (activePanel) {
          activePanel.classList.remove('is-open');
          activePanel = null;
        }
        megaMenuOverlays.forEach(o => o.classList.remove('is-active'));
      });
    });

    window.addEventListener('resize', () => {
      if (activePanel) updateMenuPosition(activePanel);
    });
    window.addEventListener('scroll', () => {
      if (activePanel) updateMenuPosition(activePanel);
    });

    function updateAllCarousels(panel) {
      if (!panel) return;
      panel.querySelectorAll('.flavor-tiles-carousel-wrap').forEach(wrap => {
        const track = wrap.querySelector('.flavor-tiles-track');
        const prevBtn = wrap.querySelector('.flavor-scroll-btn--prev');
        const nextBtn = wrap.querySelector('.flavor-scroll-btn--next');

        if (!track) return;

        const updateArrowVisibility = () => {
          if (!prevBtn || !nextBtn) return;
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll <= 4) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
          } else {
            prevBtn.style.display = track.scrollLeft > 10 ? 'flex' : 'none';
            nextBtn.style.display = track.scrollLeft < maxScroll - 10 ? 'flex' : 'none';
          }
        };

        updateArrowVisibility();

        if (!wrap.dataset.carouselBound) {
          wrap.dataset.carouselBound = 'true';

          if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
              e.preventDefault();
              track.scrollBy({ left: 300, behavior: 'smooth' });
              setTimeout(updateArrowVisibility, 350);
            });
          }

          if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              track.scrollBy({ left: -300, behavior: 'smooth' });
              setTimeout(updateArrowVisibility, 350);
            });
          }

          track.addEventListener('scroll', updateArrowVisibility);
        }
      });
    }
  }

  /* ==========================================================================
     2. Global Native Mobile Drawer Accordion Interactivity
     ========================================================================== */
  if (!window._flavorMobileBound) {
    window._flavorMobileBound = true;

    document.addEventListener('click', (e) => {
      // 1. Top-Level FLAVORS toggle button
      const topBtn = e.target.closest('[data-flavor-top-toggle], .flavor-top-btn');
      if (topBtn) {
        e.preventDefault();
        e.stopPropagation();

        const topItem = topBtn.closest('.flavor-mobile-top-item') || topBtn.parentElement;
        if (topItem) {
          topItem.classList.toggle('is-open');
          const isOpen = topItem.classList.contains('is-open');
          topBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          const panels = topItem.querySelector('.native-mobile-flavor-panels');
          if (panels) {
            panels.style.display = isOpen ? 'flex' : 'none';
          }
        }
        return;
      }

      // 2. Sub-Flavor Tab Accordion toggle button (e.g. TRADITIONAL, GARLIC)
      const toggleBtn = e.target.closest('.flavor-mobile-sub-toggle');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();

        const currentItem = toggleBtn.closest('.flavor-mobile-accordion-item');
        if (!currentItem) return;

        const container = currentItem.closest('.native-mobile-flavor-panels') || currentItem.parentElement;
        const isOpen = currentItem.classList.contains('is-open');

        if (container) {
          container.querySelectorAll('.flavor-mobile-accordion-item').forEach(item => {
            item.classList.remove('is-open');
            const btn = item.querySelector('.flavor-mobile-sub-toggle');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        }

        if (!isOpen) {
          currentItem.classList.add('is-open');
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  // Initialize on load and DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlavorMegaMenus);
  } else {
    initFlavorMegaMenus();
  }
  window.addEventListener('load', initFlavorMegaMenus);

  // Shopify Customizer Events
  document.addEventListener('shopify:section:load', initFlavorMegaMenus);
  document.addEventListener('shopify:block:select', (e) => {
    initFlavorMegaMenus();
    const targetBlock = e.target;
    if (targetBlock && targetBlock.classList.contains('flavor-panel-content')) {
      const panelId = targetBlock.id;
      document.querySelectorAll('.custom-flavor-mega-menu-panel').forEach(panel => {
        panel.classList.add('is-open');
        const matchingTab = panel.querySelector(`[data-tab-target="${panelId}"]`);
        if (matchingTab) {
          matchingTab.click();
        }
      });
    }
  });
  document.addEventListener('shopify:block:deselect', initFlavorMegaMenus);
})();


